(function () {
  var MONTH_NAMES = [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
  ];
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  var DEFAULT_MIN_QTY = 10;

  function formatEuros(n) {
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  function addBusinessDays(days) {
    var date = new Date();
    var added = 0;
    var guard = 0;
    while (added < days && guard < 60) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) added++;
      guard++;
    }
    return date;
  }

  function formatDate(date) {
    return date.getDate() + ' ' + MONTH_NAMES[date.getMonth()];
  }

  function selectButton(buttons, activeBtn, valueInput, datasetKey) {
    Array.prototype.forEach.call(buttons, function (b) {
      b.classList.remove('is-active');
    });
    activeBtn.classList.add('is-active');
    if (valueInput) valueInput.value = activeBtn.dataset[datasetKey];
  }

  function directText(el) {
    return Array.prototype.filter.call(el.childNodes, function (n) { return n.nodeType === 3; })
      .map(function (n) { return n.textContent; })
      .join('')
      .trim();
  }

  function applyColorSwatches(map) {
    var fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
    Array.prototype.forEach.call(fieldsets, function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend || directText(legend).indexOf('Couleur') !== 0) return;
      fs.classList.add('color-swatches');
      var labels = fs.querySelectorAll('label[for]:not(.color-swatch)');
      Array.prototype.forEach.call(labels, function (label) {
        var name = directText(label);
        var hex = map[name];
        if (!hex) return;
        label.classList.add('color-swatch');
        label.style.backgroundColor = hex;
        label.setAttribute('title', name);
        label.setAttribute('aria-label', name);
      });
    });
  }

  function findFieldsetByLegend(startsWith) {
    var fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && directText(legend).indexOf(startsWith) === 0) return fieldsets[i];
    }
    return null;
  }

  function findQuantityBlock() {
    var candidates = document.querySelectorAll('.product-form__quantity, .product-form__input');
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].textContent.trim().indexOf('Quant') === 0) return candidates[i];
    }
    return null;
  }

  function hideNativeSizeAndQty() {
    var taille = findFieldsetByLegend('Taille');
    if (taille) taille.classList.add('configurator-hidden-native');
    var qty = findQuantityBlock();
    if (qty) qty.classList.add('configurator-hidden-native');
    var dynamicCheckout = document.querySelector('.shopify-payment-button');
    if (dynamicCheckout) dynamicCheckout.classList.add('configurator-hidden-native');
  }

  function relocateProductHeader(root) {
    var mount = root.querySelector('[data-role="product-info"]');
    if (!mount || mount.dataset.relocated) return;
    var vendor = document.querySelector('.product__text');
    var title = document.querySelector('.product__title');
    var price = document.querySelector('[id^="price-"]');
    var taxNote = document.querySelector('.product__tax');
    var variantSelects = document.querySelector('variant-selects');
    [vendor, title, price, taxNote, variantSelects].forEach(function (el) {
      if (el) mount.appendChild(el);
    });
    mount.dataset.relocated = 'true';
  }

  function getSelectedColorValue() {
    var couleur = findFieldsetByLegend('Couleur');
    if (!couleur) return null;
    var checked = couleur.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function sizeSortIndex(name) {
    var idx = SIZE_ORDER.indexOf((name || '').toUpperCase());
    return idx === -1 ? 999 : idx;
  }

  function initSizeGrid(root) {
    var matrixEl = document.querySelector('[data-size-matrix]');
    if (!matrixEl) return null;
    var matrix;
    try {
      matrix = JSON.parse(matrixEl.textContent);
    } catch (e) {
      return null;
    }
    if (!matrix) return null;

    var hasSize = matrix.tailleIndex >= 0;
    var hasColor = matrix.couleurIndex >= 0;

    hideNativeSizeAndQty();

    var section = root.querySelector('[data-role="size-grid-section"]');
    var rowsContainer = root.querySelector('[data-role="size-rows"]');
    var totalEl = root.querySelector('[data-role="size-total"]');
    var sectionLabel = root.querySelector('[data-role="size-section-label"]');
    var sectionHint = root.querySelector('[data-role="size-section-hint"]');
    if (!section || !rowsContainer) return null;
    section.hidden = false;

    if (!hasSize) {
      if (sectionLabel) sectionLabel.textContent = 'Quantité';
      if (sectionHint) {
        sectionHint.textContent = 'Ce produit n\'a pas de tailles — indiquez simplement la quantité souhaitée (10 pièces minimum recommandé).';
      }
    }

    var optionKey = hasColor ? 'option' + (matrix.couleurIndex + 1) : null;
    var sizeKey = hasSize ? 'option' + (matrix.tailleIndex + 1) : null;

    function computeTotal() {
      var inputs = rowsContainer.querySelectorAll('input[type="number"]');
      var total = 0;
      Array.prototype.forEach.call(inputs, function (input) {
        total += parseInt(input.value, 10) || 0;
      });
      return total;
    }

    function updateTotal() {
      var total = computeTotal();
      totalEl.textContent = total > 0 ? 'Total : ' + total + ' pièce' + (total > 1 ? 's' : '') : '';
      document.dispatchEvent(new CustomEvent('configurator:sizes-changed'));
      return total;
    }

    function render() {
      var matches;
      if (hasColor) {
        var color = getSelectedColorValue();
        matches = matrix.variants.filter(function (v) { return v[optionKey] === color; });
      } else {
        matches = matrix.variants.slice(0, 1);
      }

      if (hasSize) {
        matches.sort(function (a, b) { return sizeSortIndex(a[sizeKey]) - sizeSortIndex(b[sizeKey]); });
      }

      rowsContainer.innerHTML = '';
      matches.forEach(function (v) {
        var row = document.createElement('div');
        row.className = 'product-configurator__size-row';
        if (!v.available) row.classList.add('is-unavailable');

        var label = document.createElement('span');
        label.className = 'product-configurator__size-name';
        label.textContent = hasSize ? v[sizeKey] : 'Quantité';
        row.appendChild(label);

        if (v.sku) {
          var ref = document.createElement('span');
          ref.className = 'product-configurator__size-ref';
          ref.textContent = v.sku;
          row.appendChild(ref);
        }

        var input = document.createElement('input');
        input.type = 'number';
        input.min = hasSize ? '0' : '1';
        input.step = '1';
        input.value = hasSize ? '0' : String(DEFAULT_MIN_QTY);
        input.inputMode = 'numeric';
        input.setAttribute('aria-label', hasSize ? 'Quantité taille ' + v[sizeKey] : 'Quantité');
        input.dataset.variantId = v.id;
        if (!v.available) input.disabled = true;
        input.addEventListener('input', updateTotal);
        row.appendChild(input);

        var stockLabel = document.createElement('span');
        stockLabel.className = 'product-configurator__size-status';
        stockLabel.textContent = v.available ? 'En stock' : 'Rupture';
        row.appendChild(stockLabel);

        rowsContainer.appendChild(row);
      });
      updateTotal();
    }

    render();

    var couleurFieldset = findFieldsetByLegend('Couleur');
    if (couleurFieldset) {
      couleurFieldset.addEventListener('change', render);
    }

    return {
      getSelectedSizes: function () {
        var inputs = rowsContainer.querySelectorAll('input[type="number"]');
        var out = [];
        Array.prototype.forEach.call(inputs, function (input) {
          var qty = parseInt(input.value, 10) || 0;
          if (qty > 0) out.push({ variantId: input.dataset.variantId, qty: qty });
        });
        return out;
      },
      getTotal: computeTotal,
      hideDynamicCheckout: function () {
        var btn = document.querySelector('.shopify-payment-button');
        if (btn) btn.classList.add('configurator-hidden-native');
      }
    };
  }

  function initConfigurator(root) {
    relocateProductHeader(root);

    var status = root.querySelector('.product-configurator__status');

    var feesMap = {};
    var feesEl = document.querySelector('[data-marking-fees]');
    if (feesEl) {
      try { feesMap = JSON.parse(feesEl.textContent) || {}; } catch (e) { feesMap = {}; }
    }

    var programFee = null;
    var programFeeEl = document.querySelector('[data-embroidery-program-fee]');
    if (programFeeEl) {
      try { programFee = JSON.parse(programFeeEl.textContent); } catch (e) { programFee = null; }
    }

    var markingButtons = root.querySelectorAll('[data-marking]');
    var markingFields = root.querySelector('[data-role="marking-fields"]');
    var isMarked = true;

    var techniqueButtons = root.querySelectorAll('[data-technique]');
    var techniqueValue = root.querySelector('[data-role="technique-value"]');
    var programFeeNotice = root.querySelector('[data-role="program-fee-notice"]');

    var emplacementButtons = root.querySelectorAll('[data-emplacement]');
    var logoRowsContainer = root.querySelector('[data-role="logo-rows"]');
    var logoInputs = {};

    var recapRowTechnique = root.querySelector('[data-role="recap-row-technique"]');
    var recapRowEmplacement = root.querySelector('[data-role="recap-row-emplacement"]');
    var recapRowFees = root.querySelector('[data-role="recap-row-fees"]');
    var recapFees = root.querySelector('[data-role="recap-fees"]');
    var recapRowProgramFee = root.querySelector('[data-role="recap-row-program-fee"]');
    var recapProgramFee = root.querySelector('[data-role="recap-program-fee"]');

    var delayButtons = root.querySelectorAll('[data-delay]');
    var delayValue = root.querySelector('[data-role="delay-value"]');
    var deliveryValue = root.querySelector('[data-role="delivery-value"]');
    var deliveryEstimate = root.querySelector('[data-role="delivery-estimate"]');

    var recapCouleur = root.querySelector('[data-role="recap-couleur"]');
    var recapTechnique = root.querySelector('[data-role="recap-technique"]');
    var recapEmplacement = root.querySelector('[data-role="recap-emplacement"]');
    var recapDelai = root.querySelector('[data-role="recap-delai"]');
    var recapLivraison = root.querySelector('[data-role="recap-livraison"]');
    var recapTotal = root.querySelector('[data-role="recap-total"]');
    var recapGrandTotal = root.querySelector('[data-role="recap-grandtotal"]');

    var formEl = document.querySelector('form[data-type="add-to-cart-form"]');
    var submitBtn = formEl ? formEl.querySelector('[type="submit"]') : null;

    var sizeGrid = initSizeGrid(root);
    if (sizeGrid) sizeGrid.hideDynamicCheckout();

    function currentTotalQty() {
      return sizeGrid ? sizeGrid.getTotal() : (parseInt((new FormData(formEl)).get('quantity'), 10) || 1);
    }

    function getUnitPrice() {
      var scope = root.querySelector('[data-role="product-info"]') || root;
      var candidates = scope.querySelectorAll('.price-item');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (el.offsetParent === null) continue;
        var text = el.textContent.replace(/[^0-9,]/g, '').replace(',', '.');
        var val = parseFloat(text);
        if (!isNaN(val)) return val;
      }
      return 0;
    }

    function currentFeesForTechnique() {
      return feesMap[techniqueValue.value] || {};
    }

    function isEmbroidery() {
      return isMarked && techniqueValue.value === 'Broderie' && !!programFee;
    }

    function needsProgramFee() {
      if (!isEmbroidery()) return false;
      return currentTotalQty() < programFee.threshold;
    }

    function activeEmplacements() {
      return Array.prototype.filter.call(emplacementButtons, function (b) {
        return b.classList.contains('is-active') && !b.disabled;
      }).map(function (b) { return b.dataset.emplacement; });
    }

    function updateProgramFeeNotice() {
      if (!programFeeNotice || !programFee) return;
      if (!isEmbroidery()) {
        programFeeNotice.hidden = true;
        return;
      }
      programFeeNotice.hidden = false;
      if (needsProgramFee()) {
        programFeeNotice.className = 'product-configurator__notice product-configurator__notice--warning';
        programFeeNotice.textContent = 'Programme de broderie (création du fichier) : +' + formatEuros(programFee.price) + ' — obligatoire pour les commandes de moins de ' + programFee.threshold + ' pièces.';
      } else {
        programFeeNotice.className = 'product-configurator__notice product-configurator__notice--success';
        programFeeNotice.textContent = 'Programme de broderie offert à partir de ' + programFee.threshold + ' pièces ✓';
      }
    }

    function updateEmplacementAvailability() {
      var fees = currentFeesForTechnique();
      Array.prototype.forEach.call(emplacementButtons, function (btn) {
        var name = btn.dataset.emplacement;
        var hint = btn.querySelector('[data-role="emplacement-price"]');
        var fee = fees[name];
        if (fee) {
          btn.disabled = false;
          btn.classList.remove('is-unavailable');
          if (hint) hint.textContent = '+' + formatEuros(fee.price);
        } else {
          if (btn.classList.contains('is-active')) btn.classList.remove('is-active');
          btn.disabled = true;
          btn.classList.add('is-unavailable');
          if (hint) hint.textContent = 'Indisponible';
        }
      });
      updateProgramFeeNotice();
    }

    function computeFeesTotal() {
      if (!isMarked) return 0;
      var fees = currentFeesForTechnique();
      var qty = currentTotalQty();
      var sum = 0;
      activeEmplacements().forEach(function (name) {
        if (fees[name]) sum += fees[name].price * qty;
      });
      if (needsProgramFee()) sum += programFee.price;
      return sum;
    }

    function computeGrandTotal() {
      var qty = currentTotalQty();
      return getUnitPrice() * qty + computeFeesTotal();
    }

    function updateLogoRows() {
      var active = isMarked ? activeEmplacements() : [];

      Object.keys(logoInputs).forEach(function (name) {
        if (active.indexOf(name) === -1) {
          var row = logoInputs[name].closest('.product-configurator__logo-row');
          if (row) row.remove();
          delete logoInputs[name];
        }
      });

      active.forEach(function (name) {
        if (logoInputs[name]) return;

        var row = document.createElement('div');
        row.className = 'product-configurator__logo-row';

        var wrap = document.createElement('div');
        wrap.className = 'product-configurator__upload';

        var inputId = 'ConfiguratorLogo-' + root.id + '-' + name.replace(/[^a-zA-Z0-9]/g, '');

        var label = document.createElement('label');
        label.className = 'product-configurator__upload-btn button button--secondary';
        label.setAttribute('for', inputId);
        label.textContent = 'Logo — ' + name;

        var input = document.createElement('input');
        input.type = 'file';
        input.id = inputId;
        input.className = 'visually-hidden';
        input.accept = 'image/png,image/jpeg,image/svg+xml';

        var filenameEl = document.createElement('span');
        filenameEl.className = 'product-configurator__filename';
        filenameEl.textContent = 'Aucun fichier choisi';

        input.addEventListener('change', function () {
          var file = input.files && input.files[0];
          filenameEl.textContent = file ? file.name : 'Aucun fichier choisi';
          setSubmitEnabled();
        });

        wrap.appendChild(label);
        wrap.appendChild(input);
        wrap.appendChild(filenameEl);
        row.appendChild(wrap);
        logoRowsContainer.appendChild(row);

        logoInputs[name] = input;
      });
    }

    function allLogosProvided() {
      if (!isMarked) return true;
      var names = Object.keys(logoInputs);
      if (!names.length) return false;
      return names.every(function (name) {
        return logoInputs[name].files && logoInputs[name].files[0];
      });
    }

    function updateRecap() {
      if (recapCouleur) recapCouleur.textContent = getSelectedColorValue() || '—';
      if (recapRowTechnique) recapRowTechnique.hidden = !isMarked;
      if (recapRowEmplacement) recapRowEmplacement.hidden = !isMarked;
      if (recapRowFees) recapRowFees.hidden = !isMarked;
      if (recapRowProgramFee) recapRowProgramFee.hidden = !isEmbroidery();
      if (recapProgramFee) recapProgramFee.textContent = needsProgramFee() ? formatEuros(programFee.price) : 'Offert';
      if (isMarked) {
        if (recapTechnique) recapTechnique.textContent = techniqueValue.value || '—';
        if (recapEmplacement) recapEmplacement.textContent = activeEmplacements().join(', ') || '—';
        if (recapFees) recapFees.textContent = formatEuros(computeFeesTotal());
      }
      updateProgramFeeNotice();
      if (recapDelai) recapDelai.textContent = delayValue.value || '—';
      if (recapLivraison) recapLivraison.textContent = deliveryValue.value || '—';
      if (recapTotal) recapTotal.textContent = sizeGrid ? sizeGrid.getTotal() : 0;
      if (recapGrandTotal) recapGrandTotal.textContent = formatEuros(computeGrandTotal());
    }

    function setSubmitEnabled() {
      var logosOk = allLogosProvided();
      var sizesOk = sizeGrid ? sizeGrid.getTotal() > 0 : true;
      var enabled = logosOk && sizesOk;
      if (isMarked && !activeEmplacements().length) {
        status.textContent = 'Choisissez au moins un emplacement de marquage.';
        enabled = false;
      } else if (!logosOk) {
        status.textContent = 'Ajoutez un logo pour chaque emplacement choisi.';
      } else if (!sizesOk) {
        status.textContent = 'Indiquez au moins une quantité.';
      } else {
        status.textContent = '';
      }
      if (!submitBtn) return;
      if (enabled) {
        submitBtn.removeAttribute('disabled');
        submitBtn.removeAttribute('aria-disabled');
      } else {
        submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.setAttribute('aria-disabled', 'true');
      }
    }

    Array.prototype.forEach.call(markingButtons, function (btn) {
      btn.addEventListener('click', function () {
        selectButton(markingButtons, btn, null, null);
        isMarked = btn.dataset.marking === 'avec';
        if (markingFields) markingFields.hidden = !isMarked;
        updateLogoRows();
        updateRecap();
        setSubmitEnabled();
      });
    });

    Array.prototype.forEach.call(techniqueButtons, function (btn) {
      btn.addEventListener('click', function () {
        selectButton(techniqueButtons, btn, techniqueValue, 'technique');
        updateEmplacementAvailability();
        updateLogoRows();
        updateRecap();
        setSubmitEnabled();
      });
    });

    Array.prototype.forEach.call(emplacementButtons, function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.classList.toggle('is-active');
        updateLogoRows();
        updateRecap();
        setSubmitEnabled();
      });
    });

    updateEmplacementAvailability();
    updateLogoRows();
    setSubmitEnabled();
    updateRecap();

    document.addEventListener('configurator:sizes-changed', function () {
      updateProgramFeeNotice();
      setSubmitEnabled();
      updateRecap();
    });

    var couleurFieldset = findFieldsetByLegend('Couleur');
    if (couleurFieldset) {
      couleurFieldset.addEventListener('change', updateRecap);
    }

    function updateDelay(btn) {
      Array.prototype.forEach.call(delayButtons, function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      delayValue.value = btn.dataset.delay;

      var minDays = parseInt(btn.dataset.daysMin, 10) || 1;
      var maxDays = parseInt(btn.dataset.daysMax, 10) || minDays;
      var minDate = addBusinessDays(minDays);
      var maxDate = addBusinessDays(maxDays);
      var minLabel = formatDate(minDate);
      var maxLabel = formatDate(maxDate);

      deliveryEstimate.textContent = 'Livraison estimée entre le ' + minLabel + ' et le ' + maxLabel;
      deliveryValue.value = minLabel + ' - ' + maxLabel;
      updateRecap();
    }

    Array.prototype.forEach.call(delayButtons, function (btn) {
      btn.addEventListener('click', function () {
        updateDelay(btn);
      });
    });

    var defaultDelay = root.querySelector('[data-delay].is-active') || delayButtons[0];
    if (defaultDelay) updateDelay(defaultDelay);

    function buildLogoProps(fd) {
      Object.keys(logoInputs).forEach(function (name) {
        var file = logoInputs[name].files && logoInputs[name].files[0];
        if (file) fd.append('properties[Logo - ' + name + ']', file);
      });
    }

    function buildExtraProps() {
      var props = {
        'Délai': delayValue.value,
        'Livraison estimée': deliveryValue.value
      };
      if (isMarked) {
        props['Technique'] = techniqueValue.value;
        props['Emplacements'] = activeEmplacements().join(', ');
      } else {
        props['Personnalisation'] = 'Sans marquage (produit brut)';
      }
      return props;
    }

    async function addFeeLines(totalQty) {
      if (!isMarked || !totalQty) return;
      var fees = currentFeesForTechnique();
      var names = activeEmplacements();
      for (var i = 0; i < names.length; i++) {
        var fee = fees[names[i]];
        if (!fee) continue;
        var fd = new FormData();
        fd.append('id', fee.variantId);
        fd.append('quantity', totalQty);
        fd.append('properties[Pour la commande]', 'Marquage - ' + names[i]);
        var res = await fetch('/cart/add.js', { method: 'POST', body: fd });
        if (!res.ok) throw new Error('fee add failed');
      }
      if (needsProgramFee()) {
        var fdProgram = new FormData();
        fdProgram.append('id', programFee.variantId);
        fdProgram.append('quantity', 1);
        fdProgram.append('properties[Pour la commande]', 'Création programme de broderie');
        var resProgram = await fetch('/cart/add.js', { method: 'POST', body: fdProgram });
        if (!resProgram.ok) throw new Error('program fee add failed');
      }
    }

    function submitMultiItem(evt) {
      if (evt) evt.preventDefault();
      var items = sizeGrid.getSelectedSizes();
      if (!items.length || !allLogosProvided()) {
        setSubmitEnabled();
        return;
      }
      status.textContent = 'Ajout au panier en cours…';
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

      var extraProps = buildExtraProps();
      var totalQty = sizeGrid.getTotal();

      (async function () {
        try {
          for (var i = 0; i < items.length; i++) {
            var fd = new FormData();
            fd.append('id', items[i].variantId);
            fd.append('quantity', items[i].qty);
            for (var key in extraProps) {
              fd.append('properties[' + key + ']', extraProps[key]);
            }
            if (isMarked) buildLogoProps(fd);
            var res = await fetch('/cart/add.js', { method: 'POST', body: fd });
            if (!res.ok) throw new Error('add failed');
          }
          await addFeeLines(totalQty);
          window.location.href = '/cart';
        } catch (err) {
          status.textContent = 'Une erreur est survenue lors de l\'ajout au panier. Veuillez réessayer.';
          setSubmitEnabled();
        }
      })();
    }

    function submitSingleItem(evt) {
      if (evt) evt.preventDefault();
      if (!allLogosProvided()) {
        setSubmitEnabled();
        return;
      }
      status.textContent = 'Ajout au panier en cours…';
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

      var fd = new FormData(formEl);
      var totalQty = parseInt(fd.get('quantity'), 10) || 1;
      var extraProps = buildExtraProps();
      Object.keys(extraProps).forEach(function (key) {
        fd.set('properties[' + key + ']', extraProps[key]);
      });
      if (isMarked) buildLogoProps(fd);

      (async function () {
        try {
          var res = await fetch('/cart/add.js', { method: 'POST', body: fd });
          if (!res.ok) throw new Error('add failed');
          await addFeeLines(totalQty);
          window.location.href = '/cart';
        } catch (err) {
          status.textContent = 'Une erreur est survenue lors de l\'ajout au panier. Veuillez réessayer.';
          setSubmitEnabled();
        }
      })();
    }

    if (submitBtn) {
      submitBtn.setAttribute('type', 'button');
      submitBtn.addEventListener('click', sizeGrid ? submitMultiItem : submitSingleItem);
    }
  }

  function initColorSwatches() {
    var mapEl = document.querySelector('[data-color-hex-map]');
    if (!mapEl) return;
    var map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }
    if (!map) return;

    applyColorSwatches(map);

    var target = document.querySelector('.product-form') || document.querySelector('.product') || document.body;
    var scheduled = false;
    var callCount = 0;
    var MAX_CALLS = 40;
    var observer = new MutationObserver(function () {
      if (scheduled || callCount >= MAX_CALLS) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        callCount++;
        applyColorSwatches(map);
        hideNativeSizeAndQty();
        if (callCount >= MAX_CALLS) observer.disconnect();
      }, 100);
    });
    observer.observe(target, { childList: true, subtree: true });

    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  initColorSwatches();
  document.querySelectorAll('.product-configurator').forEach(initConfigurator);
})();
